import { findDOMNode } from '../../../utils/findDOMNode';
import { computeControlWidth } from './Select.helpers';
import { SelectProps } from './Select.types';

export const createRefCallbacks = (component: any) => ({
  dropdownContentRefCallback: (dropdownEl: HTMLElement | null) => {
    if (dropdownEl) {
      dropdownEl.addEventListener(
        'mousedown',
        component.handleMouseDownOnDropdown
      );
    }
  },

  virtualizedMenuRendererRefCallback: (ref: any) => {
    if (ref) {
      component._virtualizedMenuRenderer = ref;
    }
  },

  anchorRefCallback: (anchorRef: any) => {
    const { controlWidth, target } = component.state;
    component._anchorRef = anchorRef;
    /* eslint-disable-next-line react/no-find-dom-node */
    const newTarget = findDOMNode(component._anchorRef);
    const newControlWidth = computeControlWidth(
      newTarget,
      component.props.open ?? false
    );
    if (target !== newTarget || controlWidth !== newControlWidth) {
      component.setState({
        controlWidth: newControlWidth,
        target: newTarget,
      });
    }

    const { inputRef, anchorType, multi } = component.props;
    if (inputRef) {
      const computedAnchorType = component.getAnchorType({ anchorType, multi });
      if (computedAnchorType === 'combined') {
        if (typeof inputRef === 'function') {
          inputRef(newTarget);
        } else if (typeof inputRef === 'object') {
          inputRef.current = newTarget;
        }
      }
    }
  },

  selectRefCallback: () => {
    // Hackily override Select's selectValue and handleMouseDownOnMenu to support "Load more"
    const internalSelect = component.getInternalSelect();
    if (!internalSelect) return;
    internalSelect.selectValue = component.selectValueProxy.bind(
      component,
      internalSelect.selectValue
    );
    const internalCreatableSelect = component.getInternalCreatableSelect();
    if (!internalCreatableSelect) return;
    // TODO(TS): replace this with a better check once we're okay with changing behavior
    (internalCreatableSelect as unknown as SelectProps).onInputChange =
      component.creatableOnInputChangeProxy;
  },
});
